<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">
                Envio de Inventario #
                <u>{{ current.numero }}</u>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{
                    current.estado_str
                  }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right">
                  <div class="btn-group">
                    <button class="btn btn-outline-dark" @click="imprimir">
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                  </div>
                </div>
              </h5>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <div class="row">
                <div class="col-sm-4">
                  <TiendaSelectComponent
                    :current="current"
                    v-if="!current.id"
                  />
                  <label v-if="current.id">Tienda</label>
                  <input
                    v-model="current.lugar"
                    v-if="current.id"
                    :disabled="true"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input
                      class="form-control"
                      v-model="current.usuario"
                      type="text"
                      :disabled="true"
                    />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.fecha &&
                          current.errors.fecha.length > 0,
                      }"
                      >Fecha</label
                    >
                    <input
                      v-model="fecha_str"
                      class="form-control"
                      placeholder="Fecha"
                      :disabled="true"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.fecha"
                      class="form-text text-danger"
                      >{{ current.errors.fecha[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <router-link
                v-if="current.cargo_e"
                :to="{
                  name: 'cxc-cargos-editar',
                  params: { id: current.cargo_e.id },
                }"
              >
                <h5 style="color: #1ba1db">
                  Cargo Aplicado # {{ current.cargo_e.numero }}
                </h5>
              </router-link>
              <div class="row">
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th>Lote</th>
                        <th class="text-center">Unidad de Medida</th>
                        <th class="text-center">Unidades</th>
                        <th class="text-center">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.enviod_set"
                        v-bind:key="detalle.id"
                      >
                        <td>{{ detalle.producto.sku }}</td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td v-if="detalle.producto_lote">
                          {{ detalle.producto_lote.codigo_lote }}
                        </td>
                        <td v-else></td>
                        <td
                          class="text-right bolder nowrap"
                          style="font-weight: 500"
                        >
                          <span> {{ detalle.unidad_medida.nombre }}</span>
                        </td>
                        <td
                          class="text-right bolder nowrap"
                          style="font-weight: 500"
                        >
                          <span> {{ detalle.cantidad_um }}</span>
                        </td>
                        <td>{{ detalle.valor }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div></div>
              </div>
              <div class="form-buttons-w">
                <router-link
                  class="btn btn-outline-info"
                  :to="{ name: 'inventario-envio_inventario' }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Regresar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqTraslado"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.producto &&
                          currentDetalle.errors.producto.length > 0,
                      }"
                      >Producto</label
                    >
                    <v-select
                      label="nombre"
                      v-model="currentDetalle.producto"
                      :filterable="false"
                      :options="productos"
                      @search="onSearchProducto"
                      @input="setSelected"
                    >
                      <template slot="no-options">Producto...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                    </v-select>
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.producto
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.producto[0] }}</small
                    >
                  </div>
                </div>
                <br />
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Posicion</label>
                    <v-select
                      label="nombre"
                      v-model="currentDetalle.posicion"
                      :filterable="false"
                      :options="codigo_barra"
                      @search="onSearchPosicion"
                    >
                      <template slot="no-options">Posicion...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.codigo_barra }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.codigo_barra }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12">
                  Unidad Medida:
                  <select
                    v-model="currentDetalle.unidad_medida"
                    class="form-control"
                    autofocus="autofocus"
                  >
                    <option
                      v-for="detalle in currentDetalle.productounidadmedida_set"
                      :value="detalle.unidad_medida.id"
                      v-bind:key="detalle.unidad_medida.id"
                    >
                      {{ detalle.unidad_medida.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12">
                  {{}} Lotes:
                  <select
                    v-model="currentDetalle.producto_lote"
                    v-if="
                      currentDetalle.productolote_set != null &&
                      currentDetalle.productolote_set.length > 0
                    "
                    class="form-control"
                    autofocus="autofocus"
                  >
                    <option
                      v-for="detalle in currentDetalle.productolote_set"
                      :value="detalle.id"
                      v-bind:key="detalle.id"
                    >
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                </div>
                <br />

                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                      >Cantidad en Unidades</label
                    >
                    <input
                      v-model="currentDetalle.cantidad_um"
                      class="form-control"
                      placeholder="cantidad"
                      type="text"
                      style="text-align: center"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.cantidad
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                      >Valor</label
                    >
                    <input
                      v-model="currentDetalle.valor"
                      class="form-control"
                      placeholder="Valor"
                      type="text"
                      style="text-align: center"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.cantidad
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              :disabled="
                !(
                  currentDetalle.productolote_set != null &&
                  currentDetalle.productolote_set.length > 0
                )
              "
              class="btn btn-primary"
              @click="agregaDetalle"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import EnvioInventarioService from "@/services/inventario/EnvioInventarioService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CargosService from "@/services/cxc/CargosService";
import PosicionesService from "@/services/inventario/PosicionesService";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        cargo_e: {
          id: "",
          numero: "",
        },
        codigo_barra: [],
        options: [],
        cargo: "",
        producto: "",
        productos: [],
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        enviod_set: [],
        lugar: "",
      },
      cargo: [],
      productos: [],
      codigo_barra: [],
      options: [],
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({}),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshCargo();
    }
    self.refreshCargo();
  },
  methods: {
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.productounidadmedida_set =
          res.data.productounidadmedida_set;
      });
    },

    refreshCurrent() {
      let self = this;
      EnvioInventarioService.getById(self.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda1 = response.data.tienda.codigo;
        self.current.lugar = response.data.tienda.nombre;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
      });
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      current.cargo_e = self.current.cargo_e.id;
      EnvioInventarioService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-envio_inventario-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          self.current.errors = error.response.data;
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },
    onSearchCargo(search, loading) {
      loading(true);
      this.searchCargo(loading, search, this);
    },

    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let that = this;

      PosicionesService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.codigo_barra = res.data;
        loading(false);
      });
    }, 350),

    searchCargo: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      CargosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.cargo = res.data;
        loading(false);
      });
    }, 350),

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    refreshCargo() {
      let self = this;
      CargosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.cargo = res.data.results;
      });
    },

    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        activo: true,
      }).then((res) => {
        self.codigo_barra = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
        det.posicion = det.posicion.id;
      }
      EnvioInventarioService.agregarDetalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Entrada por Traslado",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Traslado",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          EnvioInventarioService.eliminarDetalle(detalle.envio_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Envio de Inventario",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          EnvioInventarioService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Envio de Inventario",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Envio de Inventario",
        "Desea cerrar la transacción?",
        "Si Cerrar",
        function () {
          EnvioInventarioService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Envio de Inventario",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          EnvioInventarioService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Envio de Inventario",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    imprimir() {
      let self = this;
      EnvioInventarioService.pdf(self.current.id)
        .then((response) => {
          console.log(response.data.output);
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
